import Swiper from "swiper/bundle";

const MukhiSlider = () => {
  const mukhiSmallSliders = [
    ...document.querySelectorAll(".mukhi-section__small-slider"),
  ];
  const mukhiBigSliders = [
    ...document.querySelectorAll(".mukhi-section__big-slider"),
  ];

  const mukhiProductsSlideropeners = [
    ...document.querySelectorAll(".mukhi-products-opener"),
  ];
  const mukhiProducts = [
    ...document.querySelectorAll(".mukhi-section__products"),
  ];

  const bigSliderNextBtn = document.querySelector(
    ".mukhi-section__big-slider-btn-next"
  );
  const bigSliderPrevBtn = document.querySelector(
    ".mukhi-section__big-slider-btn-prev"
  );
  const smallSlides = [
    ...document.querySelectorAll(".mukhi-section__small-slide"),
  ];

  const relatedProductsClosers = [
    ...smallSlides,
    bigSliderNextBtn,
    bigSliderPrevBtn,
  ].filter((element) => element !== null);

  const findProductsPanel = (termId) =>
    mukhiProducts.find(
      (panel) => String(panel.dataset.termId) === String(termId)
    );

  const enhanceInjectedPanel = (panel) => {
    if (typeof window.mettevoInitFixFourSliders === "function") {
      window.mettevoInitFixFourSliders(panel);
    }
    if (typeof window.initializeAllSliders === "function") {
      window.initializeAllSliders(
        panel.querySelectorAll(".product-card__image-wrapper")
      );
    }
    if (typeof window.ProductCardOptions === "function") {
      window.ProductCardOptions(panel);
    }
    if (typeof window.ProductRadioBtn === "function") {
      window.ProductRadioBtn(panel);
    }
  };

  const loadingMarkup = () => `
    <div class="mukhi-section__products-loading container section-60" role="status" aria-live="polite">
      <div class="mukhi-section__products-loading-inner">
        <span class="mukhi-section__products-loading-spinner" aria-hidden="true"></span>
        <p class="mukhi-section__products-loading-text">Loading products…</p>
      </div>
    </div>
  `;

  const setOpenersBusy = (termId, isBusy) => {
    mukhiProductsSlideropeners.forEach((opener) => {
      if (String(opener.dataset.termId) !== String(termId)) {
        return;
      }
      opener.disabled = isBusy;
      opener.classList.toggle("is-loading", isBusy);
      opener.setAttribute("aria-busy", isBusy ? "true" : "false");
    });
  };

  const loadMukhiProducts = async (panel) => {
    if (!panel || panel.dataset.loaded === "1" || panel.dataset.loading === "1") {
      return;
    }

    const termId = panel.dataset.termId;
    const ajaxUrl =
      (window.theme && window.theme.ajax_url) ||
      (window.theme && window.theme.ajaxUrl) ||
      "/wp-admin/admin-ajax.php";
    const nonce = (window.theme && window.theme.nonce) || "";

    panel.dataset.loading = "1";
    panel.classList.add("is-loading");
    panel.innerHTML = loadingMarkup();
    setOpenersBusy(termId, true);

    const body = new URLSearchParams();
    body.set("action", "mettevo_mukhi_products");
    body.set("term_id", termId);
    body.set("nonce", nonce);

    try {
      const response = await fetch(ajaxUrl, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
        body: body.toString(),
      });
      const payload = await response.json();

      if (!payload || !payload.success || !payload.data || !payload.data.html) {
        throw new Error("Invalid mukhi products response");
      }

      panel.innerHTML = payload.data.html;
      panel.dataset.loaded = "1";
      enhanceInjectedPanel(panel);
    } catch (error) {
      console.error(error);
      panel.innerHTML =
        '<div class="mukhi-section__products-loading container section-60"><p class="mukhi-section__products-loading-text">Unable to load products. Please try again.</p></div>';
    } finally {
      panel.dataset.loading = "0";
      panel.classList.remove("is-loading");
      setOpenersBusy(termId, false);
    }
  };

  const openMukhiProducts = async (termId) => {
    mukhiProducts.forEach((products) => products.classList.remove("opened"));

    const panel = findProductsPanel(termId);
    if (!panel) {
      return;
    }

    panel.classList.add("opened");
    await loadMukhiProducts(panel);
  };

  if (mukhiSmallSliders.length > 0 && mukhiBigSliders.length > 0) {
    mukhiSmallSliders.forEach((mukhiSmallSlider, index) => {
      const smallMukhiCarousel = new Swiper(mukhiSmallSlider, {
        direction: "vertical",
        slidesPerView: "auto",
        freeMode: true,
        mousewheel: true,
        watchSlidesProgress: true,
        scrollbar: {
          el: ".swiper-scrollbar",
        },
      });

      const mukhiBigSlider = mukhiBigSliders[index];
      if (mukhiBigSlider) {
        const bigMukhiCarousel = new Swiper(mukhiBigSlider, {
          slidesPerView: 1,
          spaceBetween: 12,
          effect: "fade",
          speed: 500,
          navigation: {
            nextEl: ".mukhi-section__big-slider-btn-next",
            prevEl: ".mukhi-section__big-slider-btn-prev",
          },
          thumbs: {
            swiper: smallMukhiCarousel,
          },
        });

        const prioritizeActiveMukhiImage = () => {
          mukhiBigSlider
            .querySelectorAll(".mukhi-section__featured-image")
            .forEach((img) => {
              img.setAttribute("fetchpriority", "low");
            });

          const activeSlide =
            bigMukhiCarousel.slides[bigMukhiCarousel.activeIndex];
          const activeImg = activeSlide?.querySelector(
            ".mukhi-section__featured-image"
          );
          if (activeImg) {
            activeImg.setAttribute("fetchpriority", "high");
            activeImg.setAttribute("loading", "eager");
          }
        };

        bigMukhiCarousel.on("slideChange", prioritizeActiveMukhiImage);
        prioritizeActiveMukhiImage();
      }
    });
  }

  if (mukhiProductsSlideropeners.length > 0) {
    mukhiProductsSlideropeners.forEach((mukhiProductsSlideropener) => {
      mukhiProductsSlideropener.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        const termId = mukhiProductsSlideropener.dataset.termId;
        openMukhiProducts(termId);
      });
    });
  }

  if (relatedProductsClosers.length > 0) {
    relatedProductsClosers.forEach((relatedProductsCloser) => {
      relatedProductsCloser.addEventListener("click", () => {
        mukhiProducts.forEach((products) =>
          products.classList.remove("opened")
        );
      });
    });
  }
};

export default MukhiSlider;
